<template>
  <div class="header">
    <div class="header-left">
      <div class="collapse-btn" @click="collapseChage">
        <el-icon class="el-icon-s-unfold" v-show="tt"></el-icon>
        <el-icon class="el-icon-s-fold" v-show="!tt"></el-icon>
      </div>
      <div class="logo" :class="{ 'logo-collapsed': isMobile }" @click="goHome">
        <el-image style="width: 40px; height: 40px" :src="logo"></el-image>
        <span class="logo-text" v-show="!isMobile">小程序后台管理</span>
      </div>
      <!-- 返回首页按钮 -->
      <div class="home-btn" v-if="showHomeBtn" @click="goHome" title="返回首页">
        <i class="el-icon-s-home"></i>
        <span class="home-btn-text" v-show="!isMobile">首页</span>
      </div>
    </div>

    <div class="header-right">
      <div class="header-user-con">
        <!-- 消息铃铛 -->
        <div class="bell-wrap" @click.stop="toggleBell" ref="bellBox">
          <el-badge :value="unreadCount" :max="99" :hidden="unreadCount === 0" class="bell-badge">
            <i class="el-icon-bell bell-icon"></i>
          </el-badge>
          <transition name="bell-slide">
            <div v-show="bellOpen" class="bell-panel" :class="{ 'bell-panel-mobile': isMobile }" @click.stop>
              <div class="bell-head">
                <span class="bell-head-title">消息通知</span>
                <div class="bell-head-actions">
                  <el-button type="text" size="mini" :disabled="notifyList.length === 0"
                    @click="onClearAll">清空</el-button>
                </div>
              </div>
              <div v-if="notifyList.length === 0" class="bell-empty">
                <i class="el-icon-chat-dot-square"></i>
                <div>暂无新消息</div>
              </div>
              <div v-else class="bell-list">
                <div v-for="(n, i) in notifyList" :key="n.key || i" class="bell-item"
                  :class="'bell-t' + n.type" @click="onItemClick(n)">
                  <div class="bell-item-icon">{{ n.icon }}</div>
                  <div class="bell-item-main">
                    <div class="bell-item-title">{{ n.title }}</div>
                    <div class="bell-item-content">{{ n.content }}</div>
                    <div class="bell-item-foot">
                      <span v-if="n.orderNum" class="bell-item-num">{{ n.orderNum }}</span>
                      <span class="bell-item-time">{{ formatTime(n.time) }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="notifyList.length > 0" class="bell-foot" @click="goOrder">
                <span>查看全部订单 →</span>
              </div>
            </div>
          </transition>
        </div>

        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="back" size="medium">
          <span class="el-dropdown-link">
            <span class="user-name-text" v-show="!isMobile">ANALIAFLORA</span>
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { removeToken } from '@/utils/auth';
import ws from '@/utils/websocket';
export default {
  name: "Header",
  data() {
    return {
      user: {},
      tt: false,
      logo: require("@/assets/img/sq.jpg"),
      bellOpen: false,
      isMobile: false,
    };
  },
  computed: {
    notifyList() {
      return this.$store.state.notifyList || [];
    },
    unreadCount() {
      return this.$store.state.notifyUnread || 0;
    },
    showHomeBtn() {
      return this.$route.path !== '/dashboard';
    }
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth < 768;
    },
    toggleBell() {
      this.bellOpen = !this.bellOpen;
      if (this.bellOpen) {
        this.$store.commit('markAllRead');
      }
    },
    closeBell() {
      this.bellOpen = false;
    },
    onClearAll() {
      this.$confirm('确定清空全部消息记录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$store.commit('clearNotify');
      }).catch(() => { });
    },
    onItemClick() {
      this.goOrder();
    },
    goHome() {
      sessionStorage.setItem('n', '1');
      if (this.$route.path !== '/dashboard') {
        this.$router.push('/dashboard').catch(() => {});
      }
    },
    goOrder() {
      this.bellOpen = false;
      sessionStorage.setItem('n', '4');
      if (this.$route && this.$route.path !== '/orderAdm') {
        this.$router.push('/orderAdm').catch(() => { });
      }
    },
    formatTime(ts) {
      if (!ts) return '';
      const d = new Date(ts);
      const p = (n) => (n < 10 ? '0' + n : '' + n);
      const now = new Date();
      const sameDay = d.getFullYear() === now.getFullYear()
        && d.getMonth() === now.getMonth()
        && d.getDate() === now.getDate();
      if (sameDay) {
        return `今天 ${p(d.getHours())}:${p(d.getMinutes())}`;
      }
      return `${d.getMonth() + 1}-${p(d.getDate())} ${p(d.getHours())}:${p(d.getMinutes())}`;
    },
    onDocClick(e) {
      if (!this.bellOpen) return;
      const box = this.$refs.bellBox;
      if (box && !box.contains(e.target)) {
        this.closeBell();
      }
    },
    collapseChage() {
      // 手机端: 触发侧边栏打开
      if (this.isMobile) {
        this.$bus.$emit("mobile-sidebar-toggle");
        return;
      }
      this.tt = !this.tt;
      this.$bus.$emit("tt", this.tt);
    },
    back(comm) {
      if (comm == 'loginOut') {
        this.$confirm("是否确定退出登陆?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            //删除token
            removeToken();
            this.$router.push({
              path: "/login",
            }).catch(() => { })
            sessionStorage.setItem("n", "1");
            //关闭连接（使用 closeSocket 确保 manuallyClosed 标记生效，避免退出后自动重连）
            ws.closeSocket();
            this.$message.success('退出成功');
          })
          .catch(() => { });
      }

    }
  },
  created() {
    this.checkMobile();
    this.$bus.$emit("tt", this.tt);
  },
  mounted() {
    document.addEventListener('click', this.onDocClick);
    window.addEventListener('resize', this.checkMobile);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.onDocClick);
    window.removeEventListener('resize', this.checkMobile);
  },
};
</script>
<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 72px;
  font-size: 22px;
  color: #fff;
  background: #fff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-left {
  display: flex;
  align-items: center;
  height: 100%;
}

.collapse-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  float: left;
  padding: 0 21px;
  cursor: pointer;
  color: #333;
}

.header .logo {
  display: flex;
  align-items: center;
  padding: 0 30px;
  float: left;
  cursor: pointer;
}

.header .logo span {
  padding-left: 5px;
  color: #000;
  font-weight: bold;
  white-space: nowrap;
}

/* ====== 返回首页按钮 ====== */
.home-btn {
  display: flex;
  align-items: center;
  padding: 6px 14px;
  margin-left: 4px;
  border-radius: 6px;
  cursor: pointer;
  color: #409eff;
  font-size: 14px;
  font-weight: 500;
  background: #ecf5ff;
  border: 1px solid #d9ecff;
  transition: all 0.2s ease;
  user-select: none;
  -webkit-tap-highlight-color: transparent;
}

.home-btn:hover {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.home-btn:active {
  transform: scale(0.95);
}

.home-btn i {
  font-size: 18px;
  margin-right: 4px;
}

.home-btn-text {
  line-height: 1;
}

.header-right {
  float: right;
  padding-right: 50px;
}

.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}

.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
  display: flex;
  align-items: center;
}

.btn-bell-badge {
  position: absolute;
  right: 4px;
  top: 0px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
}

.user-name {
  margin-left: 10px;
}

.user-avator {
  margin-left: 20px;
}

.el-dropdown-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  color: #333;
}

.el-dropdown-menu__item {
  text-align: center;
}

/* ====== 消息铃铛 ====== */
.bell-wrap {
  position: relative;
  margin-right: 22px;
  cursor: pointer;
  user-select: none;
  line-height: 1;
}

.bell-icon {
  font-size: 22px;
  color: #606266;
  transition: color 0.2s;
}

.bell-wrap:hover .bell-icon {
  color: #409eff;
}

.bell-badge >>> .el-badge__content {
  border: 0;
  background: #f56c6c;
}

.bell-panel {
  position: absolute;
  top: 44px;
  right: -10px;
  width: 340px;
  max-height: 460px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.15);
  border: 1px solid #ebeef5;
  z-index: 2000;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.bell-panel::before {
  content: "";
  position: absolute;
  top: -6px;
  right: 18px;
  width: 12px;
  height: 12px;
  background: #fff;
  transform: rotate(45deg);
  border-top: 1px solid #ebeef5;
  border-left: 1px solid #ebeef5;
}

.bell-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  border-bottom: 1px solid #f0f2f5;
  background: #fafbfc;
}

.bell-head-title {
  font-size: 14px;
  font-weight: 600;
  color: #303133;
}

.bell-empty {
  padding: 50px 0;
  text-align: center;
  color: #c0c4cc;
  font-size: 13px;
}

.bell-empty i {
  font-size: 40px;
  display: block;
  margin-bottom: 10px;
  color: #dcdfe6;
}

.bell-list {
  overflow-y: auto;
  max-height: 340px;
}

.bell-list::-webkit-scrollbar {
  width: 6px;
}

.bell-list::-webkit-scrollbar-thumb {
  background: #dcdfe6;
  border-radius: 3px;
}

.bell-item {
  display: flex;
  gap: 10px;
  padding: 12px 16px;
  border-bottom: 1px solid #f5f7fa;
  cursor: pointer;
  transition: background 0.2s;
  position: relative;
}

.bell-item::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: transparent;
}

.bell-item.bell-t1::before { background: #67c23a; }
.bell-item.bell-t2::before { background: #909399; }
.bell-item.bell-t3::before { background: #e6a23c; }
.bell-item.bell-t4::before { background: #409eff; }

.bell-item:hover {
  background: #f5f7fa;
}

.bell-item-icon {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  font-size: 16px;
}

.bell-item-main {
  flex: 1;
  min-width: 0;
}

.bell-item-title {
  font-size: 13px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 4px;
}

.bell-item-content {
  font-size: 12px;
  color: #606266;
  line-height: 1.5;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  word-break: break-all;
}

.bell-item-foot {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 6px;
  font-size: 11px;
  color: #909399;
}

.bell-item-num {
  font-family: Menlo, Consolas, monospace;
  color: #606266;
}

.bell-foot {
  padding: 10px;
  text-align: center;
  border-top: 1px solid #f0f2f5;
  color: #409eff;
  font-size: 12px;
  cursor: pointer;
  background: #fafbfc;
}

.bell-foot:hover {
  background: #ecf5ff;
}

/* 面板过渡动效 */
.bell-slide-enter-active,
.bell-slide-leave-active {
  transition: transform 0.2s ease, opacity 0.2s ease;
}

.bell-slide-enter,
.bell-slide-leave-to {
  transform: translateY(-8px);
  opacity: 0;
}

/* ====== 平板端适配 ====== */
@media (min-width: 768px) and (max-width: 1024px) {
  .header {
    height: 56px;
  }
  .header .logo {
    padding: 0 15px;
  }
  .home-btn {
    padding: 5px 10px;
    font-size: 13px;
  }
  .home-btn i {
    font-size: 16px;
  }
  .header-right {
    padding-right: 20px;
  }
}

/* ====== 手机端适配 ====== */
@media (max-width: 767px) {
  .header {
    height: 56px;
    font-size: 18px;
  }
  .collapse-btn {
    padding: 0 12px;
    color: #333;
  }
  .logo-collapsed {
    padding: 0 8px !important;
  }
  .logo-text {
    font-size: 14px;
  }
  .home-btn {
    padding: 4px 8px;
    margin-left: 0;
    border-radius: 6px;
  }
  .home-btn i {
    font-size: 18px;
    margin-right: 0;
  }
  .header-right {
    padding-right: 12px;
  }
  .header-user-con {
    height: 56px;
  }
  .bell-wrap {
    margin-right: 12px;
  }
  .user-name-text {
    display: none;
  }
  .el-dropdown-link {
    font-size: 18px;
  }
  /* 手机端消息面板全屏化 */
  .bell-panel-mobile {
    position: fixed;
    top: 56px;
    left: 8px;
    right: 8px;
    width: auto;
    max-height: calc(100vh - 72px);
    border-radius: 8px;
  }
  .bell-panel-mobile::before {
    display: none;
  }
}
</style>
